<template>
<div class="chapter">
<div class="inner_page">
<div class="copyright" id="cop">
<p class="right"><span class="big2">Copyright</span></p>
<p class="crt">2061: Odyssey Three<br/>Copyright © 1987 by Serendib BV<br/>Foreword and Postscript Copyright © 1997 by Arthur C. Clarke<br/>Cover art to the electronic edition copyright © 2012 by RosettaBooks, LLC.</p>
<p class="crt">All rights reserved. No part of this book may be used or reproduced in any form or by any electronic or mechanical means, including information storage and retrieval systems, without permission in writing from the publisher, except by a reviewer who may quote brief passages in a review. Published by arrangement with Del Rey Books, an imprint of Random House, a division of Penguin Random House LLC.</p>
<p class="crt">Electronic edition published 2012 by RosettaBooks, LLC, New York.<br/>ISBN e-Pub edition: 9780795324857</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780795324857_epub_cop_r1.vue?7ea40cdc